"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const UndoStack_1 = __importDefault(require("../UndoStack"));
const DashboardUtils = __importStar(require("./DashboardUtils"));
const DashboardViewComponent_1 = __importDefault(require("./DashboardViewComponent"));
const QuickfiltersComponent_1 = __importDefault(require("../quickfilter/QuickfiltersComponent"));
const QuickfilterCompiler_1 = __importDefault(require("../quickfilter/QuickfilterCompiler"));
const SettingsModalComponent_1 = __importDefault(require("./SettingsModalComponent"));
const LayoutManager_1 = __importDefault(require("../layouts/LayoutManager"));
const LayoutOptionsComponent_1 = require("./LayoutOptionsComponent");
const ModalWindowComponent_1 = __importDefault(require("@mwater/react-library/lib/ModalWindowComponent"));
const layoutOptions_1 = require("./layoutOptions");
const __1 = require("..");
const expressions_ui_1 = require("@mwater/expressions-ui");
/** Dashboard component that includes an action bar at the top
 * Manages undo stack and quickfilter value
 */
class DashboardComponent extends react_1.default.Component {
    dashboardView;
    static defaultProps = { printScaling: true };
    settings;
    constructor(props) {
        super(props);
        const layoutOptions = (0, layoutOptions_1.getLayoutOptions)(props.design);
        // Prefer the T.en locale if available when loading the dashboard
        let initialLocale = props.design.locale || "en";
        const otherLocales = props.design.otherLocales || [];
        if (props.preferredLocale && otherLocales.includes(props.preferredLocale)) {
            initialLocale = props.preferredLocale;
        }
        else if (otherLocales.includes(T.locale)) {
            initialLocale = T.locale;
        }
        this.state = {
            undoStack: new UndoStack_1.default().push(props.design),
            quickfiltersValues: props.quickfiltersValues || null,
            editing: LayoutManager_1.default.createLayoutManager(props.design.layout).isEmpty(props.design.items) &&
                props.onDesignChange != null,
            layoutOptionsOpen: false,
            hideQuickfilters: layoutOptions.hideQuickfiltersWidth === 0 ||
                (layoutOptions.hideQuickfiltersWidth != null && layoutOptions.hideQuickfiltersWidth > document.body.clientWidth),
            refreshKey: 1,
            locale: initialLocale
        };
        if (props.onEditModeChange) {
            props.onEditModeChange(this.state.editing);
        }
    }
    // Get the values of the quick filters
    getQuickfilterValues = () => {
        return this.state.quickfiltersValues || [];
    };
    componentWillReceiveProps(nextProps) {
        let { undoStack } = this.state;
        // Clear stack if key changed
        if (nextProps.undoStackKey !== this.props.undoStackKey) {
            undoStack = new UndoStack_1.default();
        }
        // Save on stack
        undoStack = undoStack.push(nextProps.design);
        this.setState({ undoStack });
        // Clear quickfilters if definition changed
        if (!lodash_1.default.isEqual(this.props.design.quickfilters, nextProps.design.quickfilters)) {
            this.setState({ quickfiltersValues: nextProps.quickfiltersValues });
        }
        if (nextProps.onDesignChange == null) {
            this.setState({ editing: false });
        }
    }
    handlePrint = () => {
        this.dashboardView?.print();
    };
    handleUndo = () => {
        const undoStack = this.state.undoStack.undo();
        // We need to use callback as state is applied later
        this.setState({ undoStack }, () => this.props.onDesignChange(undoStack.getValue()));
    };
    handleRedo = () => {
        const undoStack = this.state.undoStack.redo();
        // We need to use callback as state is applied later
        this.setState({ undoStack }, () => this.props.onDesignChange(undoStack.getValue()));
    };
    // Saves a json file to disk
    handleSaveDesignFile = () => {
        // Make a blob and save
        const blob = new Blob([JSON.stringify(this.props.design, null, 2)], { type: "text/json" });
        // Require at use as causes server problems
        const FileSaver = require("file-saver");
        FileSaver.saveAs(blob, "Dashboard.json");
    };
    handleSettings = () => {
        this.settings.show(this.props.design);
    };
    handleToggleEditing = () => {
        const editing = !this.state.editing;
        this.setState({ editing });
        if (this.props.onEditModeChange) {
            this.props.onEditModeChange(editing);
        }
    };
    handleOpenLayoutOptions = () => {
        this.setState({ layoutOptionsOpen: true });
    };
    handleRefreshData = () => {
        this.props.dataSource.clearCache?.();
        this.setState({ refreshKey: this.state.refreshKey + 1 });
    };
    handleStyleChange = (style) => {
        this.props.onDesignChange(lodash_1.default.extend({}, this.props.design, { style: style || null }));
    };
    handleDesignChange = (design) => {
        // If quickfilters have changed, reset values
        if (!lodash_1.default.isEqual(this.props.design.quickfilters, design.quickfilters)) {
            this.setState({ quickfiltersValues: null });
        }
        this.props.onDesignChange(design);
    };
    handleShowQuickfilters = () => {
        return this.setState({ hideQuickfilters: false });
    };
    // Get filters from props filters combined with dashboard filters
    getCompiledFilters() {
        let compiledFilters = DashboardUtils.getCompiledFilters(this.props.design, this.props.schema, DashboardUtils.getFilterableTables(this.props.design, this.props.schema));
        compiledFilters = compiledFilters.concat(this.props.filters || []);
        return compiledFilters;
    }
    /** Translate function to use for display. Do not use when editing. */
    translate = (input) => {
        const designLocale = this.props.design.locale ?? "en";
        const displayLocale = this.state.editing ? designLocale : (this.state.locale ?? designLocale ?? "en");
        if (designLocale === displayLocale) {
            return input;
        }
        return this.props.design.translations?.[displayLocale]?.[input] ?? input;
    };
    renderEditingSwitch() {
        return (react_1.default.createElement("a", { key: "edit", className: `btn btn-primary btn-sm ${this.state.editing ? "active" : ""}`, onClick: this.handleToggleEditing },
            react_1.default.createElement("span", { className: "fas fa-pencil-alt" }),
            " ",
            this.state.editing ? T `Editing` : T `Edit`));
    }
    renderStyle() {
        return (react_1.default.createElement("button", { type: "button", key: "style", className: "btn btn-link btn-sm", onClick: this.handleOpenLayoutOptions },
            react_1.default.createElement("span", { className: "fa fa-mobile" }),
            react_1.default.createElement("span", { className: "hide-600px" },
                " ",
                T `Layout`)));
    }
    renderActionLinks() {
        return (react_1.default.createElement("div", null,
            this.state.editing
                ? [
                    react_1.default.createElement("a", { key: "undo", className: `btn btn-link btn-sm ${!this.state.undoStack.canUndo() ? "disabled" : ""}`, onClick: this.handleUndo },
                        react_1.default.createElement("span", { className: "fas fa-caret-left" }),
                        react_1.default.createElement("span", { className: "hide-600px" },
                            " ",
                            T `Undo`)),
                    " ",
                    react_1.default.createElement("a", { key: "redo", className: `btn btn-link btn-sm ${!this.state.undoStack.canRedo() ? "disabled" : ""}`, onClick: this.handleRedo },
                        react_1.default.createElement("span", { className: "fas fa-caret-right" }),
                        react_1.default.createElement("span", { className: "hide-600px" },
                            " ",
                            T `Redo`))
                ]
                : undefined,
            !this.state.editing && this.props.design.otherLocales && this.props.design.otherLocales.length > 0
                ? react_1.default.createElement("div", { key: "translations", className: "dropdown d-inline-block" },
                    react_1.default.createElement("a", { className: "btn btn-link btn-sm dropdown-toggle", "data-bs-toggle": "dropdown" },
                        react_1.default.createElement("span", { className: "fal fa-globe" }),
                        " ",
                        this.state.locale),
                    react_1.default.createElement("ul", { className: "dropdown-menu dropdown-menu-end" }, [this.props.design.locale || "en", ...this.props.design.otherLocales].map(locale => react_1.default.createElement("li", { key: locale },
                        react_1.default.createElement("a", { className: "dropdown-item", onClick: () => this.setState({ locale: locale }) }, __1.languages.find(l => l.code === locale)?.name || locale)))))
                : undefined,
            react_1.default.createElement("a", { key: "print", className: "btn btn-link btn-sm", onClick: this.handlePrint },
                react_1.default.createElement("span", { className: "fas fa-print" }),
                react_1.default.createElement("span", { className: "hide-600px" },
                    " ",
                    T `Print`)),
            react_1.default.createElement("a", { key: "refresh", className: "btn btn-link btn-sm", onClick: this.handleRefreshData },
                react_1.default.createElement("span", { className: "fas fa-sync" }),
                react_1.default.createElement("span", { className: "hide-600px" },
                    " ",
                    T `Refresh`)),
            this.state.hideQuickfilters && this.props.design.quickfilters && this.props.design.quickfilters.length > 0
                ? react_1.default.createElement("a", { key: "showQuickfilters", className: "btn btn-link btn-sm", onClick: this.handleShowQuickfilters },
                    react_1.default.createElement("span", { className: "fa fa-filter" }),
                    react_1.default.createElement("span", { className: "hide-600px" },
                        " ",
                        T `Show Quickfilters`))
                : undefined,
            this.state.editing
                ? react_1.default.createElement("a", { key: "settings", className: "btn btn-link btn-sm", onClick: this.handleSettings },
                    react_1.default.createElement("span", { className: "fas fa-cog" }),
                    react_1.default.createElement("span", { className: "hide-600px" },
                        " ",
                        T `Settings`))
                : undefined,
            this.state.editing ? this.renderStyle() : undefined,
            this.props.extraTitleButtonsElem,
            this.props.onDesignChange != null ? this.renderEditingSwitch() : undefined));
    }
    renderTitleBar() {
        return (react_1.default.createElement("div", { style: { height: 40, padding: 4 } },
            react_1.default.createElement("div", { style: { float: "right" } }, this.renderActionLinks()),
            this.props.titleElem));
    }
    renderQuickfilter() {
        return react_1.default.createElement(QuickfiltersComponent_1.default, { design: this.props.design.quickfilters || [], schema: this.props.schema, dataSource: this.props.dataSource, quickfiltersDataSource: this.props.dashboardDataSource.getQuickfiltersDataSource(), values: this.state.quickfiltersValues || undefined, onValuesChange: (values) => this.setState({ quickfiltersValues: values }), locks: this.props.quickfilterLocks, filters: this.getCompiledFilters(), hideTopBorder: this.props.hideTitleBar, 
            // Don't hide if title bar is hidden as it can't be shown again
            onHide: () => this.setState({ hideQuickfilters: true }), translate: this.translate });
    }
    renderFloatingShowQuickfiltersButton() {
        // Only show if:
        // 1. Quick filters exist
        // 2. Quick filters are hidden
        // 3. Title bar is hidden (since otherwise button is in title bar)
        if (!this.props.design.quickfilters?.length || !this.state.hideQuickfilters || !this.props.hideTitleBar) {
            return null;
        }
        return (react_1.default.createElement("div", { style: {
                position: "absolute",
                top: 5,
                right: 20,
                zIndex: 1000
            } },
            react_1.default.createElement("button", { className: "btn btn-link btn-sm", onClick: () => this.setState({ hideQuickfilters: false }) },
                react_1.default.createElement("i", { className: "fa fa-angle-double-down" }))));
    }
    refDashboardView = (el) => {
        this.dashboardView = el;
    };
    render() {
        let filters = this.props.filters || [];
        // Compile quickfilters
        filters = filters.concat(new QuickfilterCompiler_1.default(this.props.schema).compile(this.props.design.quickfilters || [], this.state.quickfiltersValues, this.props.quickfilterLocks));
        const displayLocale = this.state.editing ? this.props.design.locale || "en" : this.state.locale;
        const dashboardView = react_1.default.createElement(DashboardViewComponent_1.default, { schema: this.props.schema, dataSource: this.props.dataSource, dashboardDataSource: this.props.dashboardDataSource, ref: this.refDashboardView, design: this.props.design, onDesignChange: this.state.editing ? this.props.onDesignChange : undefined, filters: filters, onRowClick: this.props.onRowClick, namedStrings: this.props.namedStrings, hideScopes: this.state.hideQuickfilters, refreshKey: this.state.refreshKey, locale: displayLocale });
        const readonlyDashboardView = react_1.default.createElement(DashboardViewComponent_1.default, { schema: this.props.schema, dataSource: this.props.dataSource, dashboardDataSource: this.props.dashboardDataSource, ref: this.refDashboardView, design: this.props.design, filters: filters, onRowClick: this.props.onRowClick, namedStrings: this.props.namedStrings, hideScopes: this.state.hideQuickfilters, locale: displayLocale });
        // Pass active tables down to table select components so they can present a shorter list
        return react_1.default.createElement(expressions_ui_1.ActiveTablesContext.Provider, { value: DashboardUtils.getFilterableTables(this.props.design, this.props.schema) },
            react_1.default.createElement(expressions_ui_1.LocaleContext.Provider, { value: displayLocale },
                react_1.default.createElement("div", { style: {
                        display: "grid",
                        gridTemplateRows: this.props.hideTitleBar ? "auto 1fr" : "auto auto 1fr",
                        height: "100%"
                    } },
                    !this.props.hideTitleBar ? this.renderTitleBar() : undefined,
                    react_1.default.createElement("div", null, !this.state.hideQuickfilters ? this.renderQuickfilter() : undefined),
                    dashboardView,
                    this.renderFloatingShowQuickfiltersButton(),
                    this.props.onDesignChange != null && (react_1.default.createElement(SettingsModalComponent_1.default, { onDesignChange: this.handleDesignChange, schema: this.props.schema, dataSource: this.props.dataSource, ref: (c) => {
                            this.settings = c;
                        } })),
                    this.state.layoutOptionsOpen && (react_1.default.createElement(ModalWindowComponent_1.default, { isOpen: true, outerPadding: 10, innerPadding: 10, onRequestClose: () => this.setState({ layoutOptionsOpen: false }) },
                        react_1.default.createElement(LayoutOptionsComponent_1.LayoutOptionsComponent, { design: this.props.design, onDesignChange: this.props.onDesignChange, dashboardView: readonlyDashboardView, quickfiltersView: this.renderQuickfilter() }))))));
    }
}
exports.default = DashboardComponent;
